// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"782":"22c23c59","872":"c24e7f44","885":"e6139d9f"}[chunkId] + ".chunk.js";
};